export { default } from './MapCreateSpot';
